import { render, staticRenderFns } from "./gradeLearning.vue?vue&type=template&id=20bee148&scoped=true"
import script from "./gradeLearning.vue?vue&type=script&lang=js"
export * from "./gradeLearning.vue?vue&type=script&lang=js"
import style0 from "./gradeLearning.vue?vue&type=style&index=0&id=20bee148&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bee148",
  null
  
)

export default component.exports